import { gql } from "@apollo/client"
import {
  AuthorizeDirectDebitOnPaymentMethodInput,
  AuthorizeDirectDebitOnPaymentMethodPayload,
} from "@oysterhr/schema"

import { useMutation, InjectedOptions } from "@oysterhr/core"

export const PAYMENTS_COMPANY_AUTHORIZE_ACH_DIRECT_DEBIT_ON_PAYMENT_METHOD = gql`
  mutation PaymentsCompanyAuthorizeACHDirectDebitOnPaymentMethod(
    $authorized: Boolean!
    $paymentMethodId: ID!
  ) {
    authorizeDirectDebitOnPaymentMethod(
      input: { authorized: $authorized, paymentMethodId: $paymentMethodId }
    ) {
      paymentMethod {
        ... on PaymentMethodStripeAch {
          id
          state
        }
        ... on PaymentMethodStripeSepa {
          id
          state
        }
      }
      errors
    }
  }
`

export const useAuthorizePaymentMethod = (
  options?: InjectedOptions<
    { authorizeDirectDebitOnPaymentMethod: AuthorizeDirectDebitOnPaymentMethodPayload },
    AuthorizeDirectDebitOnPaymentMethodInput
  >,
) =>
  useMutation<
    { authorizeDirectDebitOnPaymentMethod: AuthorizeDirectDebitOnPaymentMethodPayload },
    AuthorizeDirectDebitOnPaymentMethodInput
  >(PAYMENTS_COMPANY_AUTHORIZE_ACH_DIRECT_DEBIT_ON_PAYMENT_METHOD, options)
